<template>
    <div>
      <header>
        <div class="w-100 bg-white box-shadow" :class="{ 'sticky': isSticky }">
        <div class="container autoContent">
          <div class="row padding-top-bottom">
             <div class="col-xl-2 col-6 col-md-2 
             logo-col">
               <div class="logo w-100 d-inline-block">
                 <router-link to="/" exact-active-class="active-link">
                   <img src="@/assets/images/logo-image.svg" alt="Dubai Pets Groomer">
                 </router-link>
               </div>
             </div>
             <div class="col-xl-6 col-6 col-md-5 ps-xl-0">
              <div class="float-end menu-button d-xl-none d-block mt-2 d-md-none" @click="toggleSidebar">
                <img src="@/assets/images/menu-button-image.png" alt="">
              </div>
              <!-- <transition name="fade" mode="out-in">
                <div :key="sidebarOpen">
                <div class="float-end menu-button d-xl-none d-block mt-2 d-md-none" @click="toggleSidebar" v-if="!sidebarOpen">
                  <img src="@/assets/images/menu-button-image.png" alt="">
                </div>
                <div v-else class="float-end 
                cross-icon-image d-xl-none d-block mt-2 d-md-none" @click="closeSidebar">
                  <img class="h-40" src="@/assets/images/cross-icon-image.png" alt="">
                </div>
              </div>
              </transition> -->
               <div class="pets-nav w-100 d-xl-inline-block d-none position-relative d-md-block">
                 <nav class="navbar navbar-expand-lg p-0 margin-top-2">
                    <div class="w-100 d-inline-block">
                      <ul class="navbar-nav me-auto mb-2 mb-lg-0 position-relative">
                        <li class="nav-item margin-nav-right-2 nav-text-link">
                          <!-- <a class="nav-link text-black text-size-15 medium-family active nav-text" href="javascript:void(0)">Home
                          </a> -->
                          <router-link class="nav-link text-black text-size-13 medium-family nav-text text-full-13 ps-xl-0" to="/" exact-active-class="active-link">Home</router-link>
                        </li>
                        <li class="nav-item margin-nav-right-3 nav-text-link">
                          <router-link class="nav-link text-black text-size-13 service-dropdown position-relative medium-family 
                          nav-text position-relative right-border text-full-13" 
                          to="/services/" exact-active-class="active-link">Services</router-link>
                          <div class="service-menu bg-white position-absolute box-shadow rounded-2">
                           <ul class="w-100 d-inline-block ps-0 text-center">
                             <li class="d-inline-block w-100">
                               <!-- <a class="nav-color text-size-14 medium-family" 
                               href="javascript">DOG GROOMING</a> -->

                          <router-link class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom border-bottom w-100" to="/services/mobile-dog-grooming-dubai-pet-groomer/" exact-active-class="active-link-service">DOG GROOMING
                          </router-link>
                             </li>
                             <li class="d-inline-block w-100">
                               <!-- <a class="nav-color text-size-14 medium-family" 
                               href="javascript">CAT GROOMING</a> -->
                               <router-link class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom border-bottom w-100" to="/services/mobile-cat-grooming-service-dubai/" exact-active-class="active-link-service">CAT GROOMING</router-link>
                             </li>
                             <li class="d-inline-block w-100">
                               <!-- <a class="nav-color text-size-14 medium-family" 
                               href="javascript">BIRD GROOMING</a> -->
                               <router-link class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom border-bottom w-100" to="/services/bird-grooming-services-dubai-pet-groomer/" exact-active-class="active-link-service">BIRD GROOMING
                               </router-link>
                             </li>
                             <li class="d-inline-block w-100">
                               <!-- <a class="nav-color text-size-14 medium-family" 
                               href="javascript">RABBIT GROOMING
                             </a> -->
                             <router-link class="nav-color text-size-13 medium-family text-full-13 d-inline-block padding-top-bottom w-100" to="/services/rabbit-grooming-dubai-mobile-pet-groomer/" exact-active-class="active-link-service">RABBIT GROOMING
                               </router-link>
                             </li>
                           </ul>
                        </div>
                        </li>
                        <li class="nav-item margin-nav-right-2 nav-text-link">
                          <!-- <a class="nav-link text-black 
                          text-size-15 medium-family nav-text position-relative right-border" href="javascript:void(0)">About Us</a> -->
                           <router-link class="nav-link text-black 
                          text-size-13 medium-family nav-text position-relative right-border text-full-13" to="/about-us" exact-active-class="active-link">About Us</router-link>
                        </li>
                        <li class="nav-item margin-nav-right-3 nav-text-link">
                          <!-- <a class="nav-link text-black 
                          text-size-15 medium-family nav-text position-relative right-border" href="javascript:void(0)">Contact</a> -->
                          <router-link class="nav-link text-black 
                          text-size-13 medium-family nav-text position-relative right-border text-full-13" to="/contact-us" exact-active-class="active-link">Contact
                               </router-link>
                        </li>
                      </ul>
                    </div>
                </nav>
               </div>
             </div>
             <div class="col-xl-4 col-6 col-md-5 margin-top-1">
               <!-- <div class="pets-nav-btn float-end margin-top-2 d-xl-inline-block d-none d-md-block"> -->
                 <!-- <button type="button" class="text-white text-size-11 bg-call border-0 me-2 inter-semi-bold text-uppercase text-full-11">
                          <img src="@/assets/images/call-icon.svg" 
                          alt="" class="me-2">
                          Call Now
                        </button> -->
                        <!-- <button type="button" class="text-white text-size-11 bg-online-book border-0 bg-green inter-semi-bold text-uppercase text-full-11">
                          <img src="@/assets/images/book-online-icon.svg" alt="" class="me-2">
                          Book online
                        </button> -->
                        <div class="pets-nav-btn float-end margin-top-3 d-xl-inline-block d-none d-md-block">
                          <!-- Call Now Button -->
                          <!-- <a href="javascript:void(0)" @click="openCall" class="text-white text-size-11 bg-call border-0 me-2 inter-semi-bold text-uppercase text-full-11">
                            <img src="@/assets/images/call-icon.svg" alt="" class="me-2">
                            Call Now
                          </a> -->

                          <!-- WhatsApp Button -->
                          <!-- <a class="text-white text-size-14 d-inline-block bg-call inter-bold-family whats-btn text-uppercase text-full-11" href="javascript:void(0)" @click="openWhatsApp">
                <i class="fa fa-whatsapp text-size-20 text-full-18 me-2 float-start" aria-hidden="true"></i>
                WhatsApp 
              </a> -->
                          <a
                            class="text-white text-size-14 d-inline-block bg-call inter-bold-family whats-btn text-uppercase text-full-11 me-2 py-1"
                            :href="whatsappUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            @click="onWhatsAppClick"
                          >
                            <i class="fa fa-whatsapp text-size-20 text-full-18 me-2 float-start" aria-hidden="true"></i>
                            WhatsApp
                          </a>
                          
                          <!-- Book Online Button -->
                          <router-link class="text-white text-size-11 bg-online-book border-0 bg-green inter-semi-bold text-uppercase text-full-11" to="/booking/">
                            <img src="@/assets/images/book-online-icon.svg" alt="" class="me-2">
                            Book Online
                          </router-link>
                        </div>

               <!-- </div> -->
             </div>
          </div>
          <div v-if="$route.path === '/booking/' || $route.path === '/date'" class="row pb-2">
            <div class="col-12">
                <a class="text-black text-size-18 margin-right-2 text-full-18" href="javascript:void(0)" @click="handleBackNavigation">
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="javascript:void(0)" v-if="$route.path === '/booking/'" class="mb-0 text-size-13 family-inter-light strike-text fw-bold text-full-13">
                  Step 1 of 3
                </a>
                <a href="javascript:void(0)" v-else-if="$route.path === '/date'" class="mb-0 text-size-13 family-inter-light strike-text fw-bold text-full-13">
                  Step 2 of 3
                </a>
            </div>
          </div>
        </div>
      </div>
      </header>
      <div class="d-xl-none sidebar bg-white box-shadow p-2 d-block d-md-none" :class="['sidebar', { 'open': sidebarOpen }]">
            <div class="row">
              <div class="col-6">
                <div class="logo w-100 
                d-inline-block">
                 <router-link to="/" exact-active-class="active-link">
                   <img src="@/assets/images/logo-image.svg" alt="Dubai Pets Groomer">
                 </router-link>
               </div>
              </div>
              <div class="col-6">
                <div class="float-end 
                cross-icon-image" @click="closeSidebar">
                  <img class="h-40" src="@/assets/images/cross-icon-image.png" alt="">
                </div>
              </div>
              <div class="col-12">
                <div class="pets-nav w-100 d-xl-inline-none d-block position-relative">
                 <nav class="navbar navbar-expand-lg p-0 mt-2">
                    <div class="w-100 d-inline-block">
                      <ul class="navbar-nav me-auto mb-2 mb-lg-0 position-relative">
                        <li class="nav-item nav-text-link ps-2">
                          <!-- <a class="nav-link text-black text-size-15 medium-family active nav-text" href="javascript:void(0)">Home
                          </a> -->
                          <router-link class="nav-link text-black text-size-17 medium-family nav-text pt-3 pb-3" to="/" exact-active-class="active-link">Home</router-link>
                        </li>
                        <li class="nav-item nav-text-link" ref="accordionWrapper">
    <div class="service-accordion accordion accordion-flush" id="accordionFlushExample">
      <div class="accordion-item">
        <a
          class="nav-link text-black text-size-17 position-relative medium-family nav-text pt-3 ps-2 pe-0 pb-3 service-dropdown-2 accordion-button w-100 d-inline-block"
          :class="{ collapsed: !isAccordionOpen }"
          @click="toggleAccordion"
        >
          Services
        </a>

        <div
          id="flush-collapseOne"
          class="accordion-collapse collapse"
          :class="{ show: isAccordionOpen }"
        >
          <div class="accordion-body p-0 mt-2">
            <div class="border p-2 rounded-3 w-100">
              <ul class="w-100 d-inline-block p-2">
                <li class="d-inline-block w-100 pb-3">
                  <router-link
                    class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3"
                    to="/services/mobile-dog-grooming-dubai-pet-groomer/"
                    exact-active-class="active-link-service"
                  >DOG GROOMING</router-link>
                </li>
                <li class="d-inline-block w-100 pb-3">
                  <router-link
                    class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3"
                    to="/services/mobile-cat-grooming-service-dubai/"
                    exact-active-class="active-link-service"
                  >CAT GROOMING</router-link>
                </li>
                <li class="d-inline-block w-100 pb-3">
                  <router-link
                    class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3"
                    to="/services/bird-grooming-services-dubai-pet-groomer/"
                    exact-active-class="active-link-service"
                  >BIRD GROOMING</router-link>
                </li>
                <li class="d-inline-block w-100">
                  <router-link
                    class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3"
                    to="/services/rabbit-grooming-dubai-mobile-pet-groomer/"
                    exact-active-class="active-link-service"
                  >RABBIT GROOMING</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
                        <!-- <li class="nav-item nav-text-link">
                          <div class="service-accordion accordion accordion-flush" id="accordionFlushExample">
                            <div class="accordion-item">
                              <a class="nav-link text-black text-size-17 position-relative medium-family nav-text pt-3 ps-2 pe-0 pb-3 service-dropdown-2 accordion-button collapsed w-100 d-inline-block" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">Services
                              </a>
                              <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                              <div class="accordion-body p-0 mt-2">
                                <div class="border p-2 rounded-3 w-100">
                                 <ul class="w-100 d-inline-block 
                                 p-2">
                                   <li class="d-inline-block w-100 pb-3">
                                <router-link class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3" to="/services/mobile-dog-grooming-dubai-pet-groomer/" exact-active-class="active-link-service">DOG GROOMING
                                </router-link>
                                   </li>
                                   <li class="d-inline-block w-100 pb-3">
                                     <router-link class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3" to="/services/mobile-cat-grooming-service-dubai/" exact-active-class="active-link-service">CAT GROOMING</router-link>
                                   </li>
                                   <li class="d-inline-block w-100 pb-3">
                                     <router-link class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3" to="/services/bird-grooming-services-dubai-pet-groomer/" exact-active-class="active-link-service">BIRD GROOMING
                                     </router-link>
                                   </li>
                                   <li class="d-inline-block w-100">
                                   <router-link class="nav-color text-size-14 medium-family padding-top-bottom w-100 d-inline-block rounded-3 ps-3" to="/services/rabbit-grooming-dubai-mobile-pet-groomer/" exact-active-class="active-link-service">RABBIT GROOMING
                                     </router-link>
                                   </li>
                                 </ul>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </li> -->
                        <li class="nav-item nav-text-link">
                          <!-- <a class="nav-link text-black 
                          text-size-15 medium-family nav-text position-relative right-border" href="javascript:void(0)">About Us</a> -->
                           <router-link class="nav-link text-black text-size-17 medium-family nav-text position-relative right-border pt-3 pb-3 ps-2" to="/about-us" exact-active-class="active-link">About Us</router-link>
                        </li>
                        <li class="nav-item nav-text-link">
                          <!-- <a class="nav-link text-black 
                          text-size-15 medium-family nav-text position-relative right-border" href="javascript:void(0)">Contact</a> -->
                          <router-link class="nav-link text-black text-size-17 medium-family nav-text position-relative right-border pt-3 pb-3 ps-2" to="/contact-us" exact-active-class="active-link">Contact
                          </router-link>
                        </li>
                        <li class="nav-item nav-text-link">
                          <router-link class="nav-link text-black text-size-17 medium-family nav-text position-relative right-border pt-3 pb-3 ps-2" to="/services/" exact-active-class="active-link">How it Works
                          </router-link>
                        </li>
                      </ul>
                    </div>
                </nav>
               </div>
               <div class="w-100 d-inline-block 
               mt-2 text-center mb-3 sidebar-btn">
                 <!-- <a href="javascript:void(0)" @click="openCall" class="text-white text-size-15 bg-call-btn border-0 me-2 inter-semi-bold text-uppercase text-full-11">
                  <img src="@/assets/images/call-icon.svg" alt="" class="me-2 h-16">
                  Call Now
                </a> -->
                <!-- Book Online Button -->
                <router-link class="text-white text-size-15 bg-book-btn border-0 bg-green inter-semi-bold text-uppercase text-full-11" to="/booking/">
                  <img src="@/assets/images/book-online-icon.svg" alt="" class="me-2 h-16">
                  Book Online
                </router-link>
               </div>
              </div>
            </div>
          </div>
    </div>
  </template>
  
  <script>
  import { trackEvent, WHATSAPP_URL } from '@/utils/seo';

  export default {
    name: 'headerComponent',
    data() {
      return {
        isSticky: false,
        sidebarOpen: false,
        isAccordionOpen: false,
        whatsappUrl: WHATSAPP_URL,
      };
    },
    methods: {
      toggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen;
    },
    handleClickOutside(event) {
      if (
        this.isAccordionOpen &&
        this.$refs.accordionWrapper &&
        !this.$refs.accordionWrapper.contains(event.target)
      ) {
        this.isAccordionOpen = false;
      }
    },
     async openCall() {
        trackEvent('phone_click', { source: 'header' });
        await this.callClick('call');
        window.location.href = 'tel:+971522809076';
      },  
      async callClick(method) {
       try {
        const payload = {
          website_name: this.$websiteName,
          type: method,
          ip: 'call',
        
        };
        await this.$axios.post('/click-count', payload);
        
      } catch (err) {
        console.error('Error during call click:', err);
      }
    },
      handleBackNavigation() {
      if (this.$route.path === '/booking/') {
        this.$router.push('/');
      } else if (this.$route.path === '/date') {
        this.$router.push('/booking/');
      }
    },
      onWhatsAppClick() {
        trackEvent('whatsapp_click', { source: 'header' });
        this.callClick('whatsapp');
      },
      openWhatsApp() {
        trackEvent('chat_open', { source: 'header' });
        window.dispatchEvent(new CustomEvent('open-whatsapp-chat'));
  },
      handleScroll() {
            const scrollPosition = window.scrollY;
            const offset = 100; // Adjust this value as per your requirement
            if (scrollPosition > offset) {
                this.isSticky = true;
            } else {
                this.isSticky = false;
            }
        },
        toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  },
  closeSidebar() {
    this.sidebarOpen = false;
  }
    },
     mounted() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener("click", this.handleClickOutside);
  },
  }
  </script>
  
  <style scoped>
  
  </style>